import { render, staticRenderFns } from "./adminRequestsList.vue?vue&type=template&id=a9e16d58&scoped=true&"
import script from "./adminRequestsList.vue?vue&type=script&lang=js&"
export * from "./adminRequestsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e16d58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
